export default __webpack_public_path__ + "static/media/niftynaut.bff6a57d.jpg";